import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAll as getChapterResponseData } from 'actions/chapter-analytics';
import { store } from 'redux-rest-reducer';
import { Checkbox, Label } from 'semantic-ui-react';
import Plot from 'react-plotly.js';
import { aggregateNodes } from './utils/chapter-compare';
import ChapterAggregationTable from './chtable-analytics';
import { SCORE_COLOR, TIME_COLOR } from 'constants/plot-constants';

export class ChapterAnalytics extends PureComponent {
  constructor() {
    super();
    this.state = {
      xAxisData: null,
      chapterData: null,
      xAxisDataLabel: null,
      toggleTimeData: false,
    };
  }

  static getDerivedStateFromProps({ chapterAnalytics, chapterCode, chapterVersion }) {
    if (chapterAnalytics) {
      //console.log("getDerivedStateFromProps", chapterCode, chapterVersion)
      let newState = {};
      const chapterData = store.getAll(chapterAnalytics, { chapterCode, chapterVersion });
      if (chapterData && chapterData.data) {
        newState['chapterData'] = chapterData.data;
        const {
          xAxisDataLabel,
          xAxisData,
          scoreList,
          timeList,
          quartile3TimeList,
          quartile1ScoreList,
          quartile1TimeList,
          quartile3ScoreList,
        } = aggregateNodes(chapterData.data);
        newState['xAxisDataLabel'] = xAxisDataLabel;
        newState['xAxisData'] = xAxisData;
        newState['scoreList'] = scoreList;
        newState['timeList'] = timeList;
        newState['quartile1ScoreList'] = quartile1ScoreList;
        newState['quartile3ScoreList'] = quartile3ScoreList;
        newState['quartile1TimeList'] = quartile1TimeList;
        newState['quartile3TimeList'] = quartile3TimeList;
      }
      if (newState !== {}) {
        return newState;
      }
    }
    return null;
  }

  componentDidMount() {
    const { chapterCode, chapterVersion } = this.props;
    const { getChapterResponseData } = this.props.actions;
    getChapterResponseData({ chapterCode, chapterVersion });
  }
  toggleTimeCheckbox = () =>
    this.setState(prevState => ({ toggleTimeData: !prevState.toggleTimeData }));

  getData = () => {
    const {
      toggleTimeData,
      xAxisDataLabel,
      scoreList,
      timeList,
      quartile3TimeList,
      quartile1ScoreList,
      quartile1TimeList,
      quartile3ScoreList,
    } = this.state;
    //console.log('quartile3TimeList getData', quartile3TimeList, quartile3ScoreList);
    let data = [
      {
        x: xAxisDataLabel,
        y: toggleTimeData ? timeList : scoreList,
        type: 'bar',
        name: toggleTimeData ? 'TimeData' : 'ScoreData',
        mode: 'lines+percent',
        tickfont: { color: 'rgb(178, 34, 34, 0.5)' },
        marker: { color: toggleTimeData ? TIME_COLOR : SCORE_COLOR },
      },
      {
        x: xAxisDataLabel,
        y: toggleTimeData ? quartile3TimeList : quartile1ScoreList,
        mode: 'line+markers',
        name: 'Bottom 25% Quartile',
        fill: toggleTimeData ? 'tonexty' : 'tozeroy',
        type: 'scatter',
        tickfont: { color: 'rgba(0,0,0,0.89)' },
        visible: 'legendonly',
      },
      {
        x: xAxisDataLabel,
        y: toggleTimeData ? quartile1TimeList : quartile3ScoreList,
        mode: 'line+markers',
        name: 'Top 25% Quartile',
        fill: toggleTimeData ? 'tozeroy' : 'tonexty',
        type: 'scatter',
        tickfont: { color: 'rgb(172, 34, 34, 0.08)' },
        visible: 'legendonly',
      },
    ];

    return data;
  };

  render() {
    const { chapterCode, chapterVersion } = this.props;
    const { toggleTimeData, xAxisDataLabel, chapterData } = this.state;
    return (
      <Fragment>
        <tr />
        <Label>
          {' '}
          Score <Checkbox toggle onChange={this.toggleTimeCheckbox} /> Time{' '}
        </Label>
        {xAxisDataLabel && (
          <Plot
            data={this.getData()}
            layout={{
              width: 1000,
              height: 700,
              hoverlabel: { bgcolor: '#FFF' },
              title: ' '.concat(
                chapterCode,
                '-V',
                chapterVersion,
                ' ',
                toggleTimeData ? 'Time(minutes) Plot' : 'Chapter plot',
              ),
              yaxis: {
                title: toggleTimeData ? 'Time(minutes)' : 'Accuracy',
                range: toggleTimeData ? [1, 100] : [0, 1],
                autorange: toggleTimeData,
                tickformat: toggleTimeData ? '.0' : ',.0%',
              },
            }}
          />
        )}
        <ChapterAggregationTable data={chapterData} />
      </Fragment>
    );
  }
}

export default connect(
  (
    { chapterAnalytics },
    { match: { params: { chapterCode, chapterVersion } } = {} },
  ) => ({
    chapterAnalytics: chapterAnalytics,
    chapterCode: chapterCode,
    chapterVersion: chapterVersion,
  }),
  dispatch => ({
    actions: bindActionCreators({ getChapterResponseData }, dispatch),
  }),
)(ChapterAnalytics);
